import { useTranslation } from "react-i18next";
import { Divider } from "@hawkins/components";

import { TranslationNamespace } from "../../types";
import { Repeater } from "./Repeater";
import { PhoneInputFormControl } from "./inputs/PhoneInput";

type PhoneRepeaterProps = {
  methods: any;
  disabled?: boolean;
};

export function PhoneRepeater({ methods, disabled = false }: PhoneRepeaterProps) {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <>
      <Repeater
        name="memberIdPayload.phoneNumbers"
        componentGenerator={(idx) => (
          <PhoneInputFormControl
            key={`phone-${idx}`}
            name={`memberIdPayload.phoneNumbers.${idx}`}
            label={t("emer_field1_option3")}
            placeholder={"+X XXX-XXX-XXXX"}
            requirementType="required-star"
            style={{ width: 'clamp(25vw, 50vw, 500px)' }}
            data-testid={`phone-input-${idx}`}
          />
        )}
        defaultValueGenerator={() => ''}
        removeText={t('button_remove')}
        addText={t('button_add')}
        methods={methods}
        disabled={disabled}
      />
      <Divider />
    </>
  );
}